<script>
import AppIcon from '@/common/AppIcon.vue';
import ContentLoader from '@/common/ContentLoader.vue';

export default {
  name: 'AppCopyField',
  components: { AppIcon, ContentLoader },
  props: {
    loading: Boolean,
    label: { type: String, required: true },
    value: { type: String, required: true },
    copyValue: { type: String, default: null }
  },
  data() {
    return { message: '', showCopied: false, copyFeedbackTimer: null };
  },
  beforeDestroy() {
    clearTimeout(this.copyFeedbackTimer);
  },
  methods: {
    async copy() {
      if (this.loading) return;
      try {
        await navigator.clipboard.writeText(this.copyValue === null ? this.value : this.copyValue);
        this.message = `${this.label} copied`;
        clearTimeout(this.copyFeedbackTimer);
        this.showCopied = true;
        this.copyFeedbackTimer = setTimeout(() => {
          this.showCopied = false;
        }, 2500);
      } catch {
        clearTimeout(this.copyFeedbackTimer);
        this.showCopied = false;
        this.message = 'Select and copy the text in the field.';
      }
    }
  }
};
</script>

<template>
  <div>
    <div
      class="app-copy-field"
      :class="{ 'app-copy-field-loading': loading }"
      :aria-busy="loading"
      :aria-label="loading ? `Loading ${label.toLowerCase()}` : null"
    >
      <content-loader v-if="loading" class="absolute" aria-hidden="true" />
      <template v-else>
        <span class="app-copy-field-label">{{ label }}</span>
        <span class="app-copy-field-value">{{ value }}</span>
        <button type="button" :class="{ 'app-copy-field-copied': showCopied }" :aria-label="`Copy ${label.toLowerCase()}`" @click="copy">
          <app-icon class="app-copy-field-copy-icon" type="svg" name="copy-field" aria-hidden="true" />
          <app-icon class="app-copy-field-success-icon" type="img" src="https://media.double.giving/images/checkmark-success.svg" aria-hidden="true" />
        </button>
      </template>
    </div>
    <span class="app-copy-field-status" role="status">{{ message }}</span>
  </div>
</template>
